import {IDragConfig, IDragConfigProps} from "../../interfaces/dragInterfaces";
import {IOffset, IOffsetCss, IPoint, ISize} from "../../interfaces/coordinateInterfaces";
import DropZone from "../../../formability/form_builder/services/drag/dropZone";

export default abstract class DragConfig implements IDragConfig {
  debug: boolean;
  dragThreshold: number = 20;
  draggableClass: string;
  draggableClasses: string[];
  draggableSelector: string;
  draggableSelectors: string[];
  dragOffset: IPoint;
  droppableSelector: string;
  droppableSelectors: string[];
  droppableClasses: string[];
  dropZone: DropZone;
  event: any;
  onDrop: (...args: any[]) => void;
  originDragCoords: IPoint;
  wasDragged: boolean;
  $draggedElement: JQuery<HTMLElement>;
  $originalElement: JQuery<HTMLElement>;

  protected constructor(props: IDragConfigProps) {
    this.init(props);
  }

  abstract createDragClone(event: MouseEvent): void;

  abstract animateBack(): void;

  abstract animate($element: JQuery<HTMLElement>, config: Partial<IOffsetCss & ISize>, callback?: () => void): void;

  abstract dropInZone(...args): void;

  abstract drag(event: MouseEvent): void;

  abstract hoverOver($element: JQuery<HTMLElement>, event: MouseEvent): void;

  abstract stopDrag(): void;

  abstract stopDragOnEmptyDropZone($emptyDragZone: JQuery<HTMLElement>, event: MouseEvent): void;

  abstract mouseOut($element: JQuery<HTMLElement>, event: MouseEvent): void;

  abstract delegatingDrop($element: JQuery<HTMLElement>, event: MouseEvent): boolean;

  getFixedOffset($element: JQuery<HTMLElement>): IOffset {
    const elementOffset = $element.offset();
    const $document = $(document);
    return {
      top: elementOffset.top - $document.scrollTop(),
      left: elementOffset.left - $document.scrollLeft(),
    };
  }

  getFixedOffsetCss($element: JQuery<HTMLElement>): IOffsetCss {
    const offset = this.getFixedOffset($element);
    return {
      top: offset.top + 'px',
      left: offset.left + 'px',
    };
  }

  wasEnoughDrag(startPoint: IPoint, endPoint: IPoint): boolean {
    return Math.abs(startPoint.x - endPoint.x) > this.dragThreshold || Math.abs(startPoint.y - endPoint.y) > this.dragThreshold;
  }

  private init(props: IDragConfigProps) {
    Object.assign(this, props);
    this.$originalElement = $(this.event.currentTarget);
    this.draggableClass = this.draggableClasses.find(c => this.$originalElement.hasClass(c));
    this.draggableSelectors = this.draggableClasses.map(c => `.${c}`);
    this.draggableSelector = this.draggableSelectors.join(', ');
    this.droppableSelectors = this.droppableClasses.map(c => `.${c}`);
    this.droppableSelector = this.droppableSelectors.join(', ');
    this.originDragCoords = {x: this.event.clientX, y: this.event.clientY};
  }
}